import { atom } from 'jotai';

export const urlToReturnAtom = atom<string>('');
